import { css } from 'styled-components'

export const cssTextHeader1 = css`
	font-weight: bold;
	font-size: 32px;
`
export const cssTextHeader1_100 = css`
	${cssTextHeader1};
	line-height: 100%;
`
export const cssTextHeader1_130 = css`
	${cssTextHeader1};
	line-height: 130%;
`
export const cssTextHeader1_150 = css`
	${cssTextHeader1};
	line-height: 150%;
`

/**  */

export const cssTextHeader2 = css`
	font-weight: bold;
	font-size: 24px;
`
export const cssTextHeader2_100 = css`
	${cssTextHeader2};
	line-height: 100%;
`
export const cssTextHeader2_130 = css`
	${cssTextHeader2};
	line-height: 130%;
`
export const cssTextHeader2_150 = css`
	${cssTextHeader2};
	line-height: 150%;
`

/** */

export const cssTextHeader3 = css`
	font-weight: bold;
	font-size: 18px;
`
export const cssTextHeader3_100 = css`
	${cssTextHeader3};
	line-height: 100%;
`
export const cssTextHeader3_130 = css`
	${cssTextHeader3};
	line-height: 130%;
`
export const cssTextHeader3_150 = css`
	${cssTextHeader3};
	line-height: 150%;
`

/** */

export const cssTextRegular18 = css`
	font-size: 18px;
`
export const cssTextRegular18_100 = css`
	${cssTextRegular18};
	line-height: 100%;
`
export const cssTextRegular18_130 = css`
	${cssTextRegular18};
	line-height: 130%;
`
export const cssTextRegular18_150 = css`
	${cssTextRegular18};
	line-height: 150%;
`

/** */

export const cssTextMedium16 = css`
	font-weight: 500;
	font-size: 16px;
`
export const cssTextMedium16_100 = css`
	${cssTextMedium16};
	line-height: 100%;
`
export const cssTextMedium16_130 = css`
	${cssTextMedium16};
	line-height: 130%;
`
export const cssTextMedium16_150 = css`
	${cssTextMedium16};
	line-height: 150%;
`

/** */

export const cssTextRegular16 = css`
	font-size: 16px;
`
export const cssTextRegular16_100 = css`
	${cssTextRegular16};
	line-height: 100%;
`
export const cssTextRegular16_130 = css`
	${cssTextRegular16};
	line-height: 130%;
`
export const cssTextRegular16_150 = css`
	${cssTextRegular16};
	line-height: 150%;
`

/** */

export const cssTextBold16 = css`
	font-weight: bold;
	font-size: 16px;
`
export const cssTextBold16_100 = css`
	${cssTextBold16};
	line-height: 100%;
`
export const cssTextBold16_130 = css`
	${cssTextBold16};
	line-height: 130%;
`
export const cssTextBold16_150 = css`
	${cssTextBold16};
	line-height: 150%;
`

/** */

export const cssTextBold14 = css`
	font-weight: bold;
	font-size: 14px;
`
export const cssTextBold14_100 = css`
	${cssTextBold14};
	line-height: 100%;
`
export const cssTextBold14_130 = css`
	${cssTextBold14};
	line-height: 130%;
`
export const cssTextBold14_150 = css`
	${cssTextBold14};
	line-height: 150%;
`

/** */

export const cssTextMedium14 = css`
	font-weight: 500;
	font-size: 14px;
`
export const cssTextMedium14_100 = css`
	${cssTextMedium14};
	line-height: 100%;
`
export const cssTextMedium14_130 = css`
	${cssTextMedium14};
	line-height: 130%;
`
export const cssTextMedium14_150 = css`
	${cssTextMedium14};
	line-height: 150%;
`

/** */

export const cssTextRegular14 = css`
	font-size: 14px;
`
export const cssTextRegular14_100 = css`
	${cssTextRegular14};
	line-height: 100%;
`
export const cssTextRegular14_130 = css`
	${cssTextRegular14};
	line-height: 130%;
`
export const cssTextRegular14_150 = css`
	${cssTextRegular14};
	line-height: 150%;
`

/** */

export const cssTextLight14 = css`
	font-weight: 300;
	font-size: 14px;
`
export const cssTextLight14_100 = css`
	${cssTextLight14};
	line-height: 100%;
`
export const cssTextLight14_130 = css`
	${cssTextLight14};
	line-height: 130%;
`
export const cssTextLight14_150 = css`
	${cssTextLight14};
	line-height: 150%;
`

/** */

export const cssTextMedium12 = css`
	font-weight: 500;
	font-size: 12px;
`
export const cssTextMedium12_100 = css`
	${cssTextMedium12};
	line-height: 100%;
`
export const cssTextMedium12_130 = css`
	${cssTextMedium12};
	line-height: 130%;
`
export const cssTextMedium12_150 = css`
	${cssTextMedium12};
	line-height: 150%;
`

/** */

export const cssTextRegular12 = css`
	font-size: 12px;
`
export const cssTextRegular12_100 = css`
	${cssTextRegular12};
	line-height: 100%;
`
export const cssTextRegular12_130 = css`
	${cssTextRegular12};
	line-height: 130%;
`
export const cssTextRegular12_150 = css`
	${cssTextRegular12};
	line-height: 150%;
`

/** */

export const cssTextLight12 = css`
	font-weight: 300;
	font-size: 12px;
`
export const cssTextLight12_100 = css`
	${cssTextLight12};
	line-height: 100%;
`
export const cssTextLight12_130 = css`
	${cssTextLight12};
	line-height: 130%;
`
export const cssTextLight12_150 = css`
	${cssTextLight12};
	line-height: 150%;
`

/** */

export const cssTextMedium10 = css`
	font-weight: 500;
	font-size: 10px;
`
export const cssTextMedium10_100 = css`
	${cssTextMedium10};
	line-height: 100%;
`
export const cssTextMedium10_130 = css`
	${cssTextMedium10};
	line-height: 130%;
`
export const cssTextMedium10_150 = css`
	${cssTextMedium10};
	line-height: 150%;
`

/** */

export const cssTextRegular10 = css`
	font-size: 10px;
`
export const cssTextRegular10_100 = css`
	${cssTextRegular10};
	line-height: 100%;
`
export const cssTextRegular10_130 = css`
	${cssTextRegular10};
	line-height: 130%;
`
export const cssTextRegular10_150 = css`
	${cssTextRegular10};
	line-height: 150%;
`

/** */

export const cssTextLight10 = css`
	font-weight: 300;
	font-size: 10px;
`
export const cssTextLight10_100 = css`
	${cssTextLight10};
	line-height: 100%;
`
export const cssTextLight10_130 = css`
	${cssTextLight10};
	line-height: 130%;
`
export const cssTextLight10_150 = css`
	${cssTextLight10};
	line-height: 150%;
`

/** */

export const cssTextBold10 = css`
	font-weight: bold;
	font-size: 10px;
`
export const cssTextBold10_100 = css`
	${cssTextBold10};
	line-height: 100%;
`
export const cssTextBold10_130 = css`
	${cssTextBold10};
	line-height: 130%;
`
export const cssTextBold10_150 = css`
	${cssTextBold10};
	line-height: 150%;
`

/** */

export const cssTextStrikethrough12 = css`
	text-decoration-line: line-through;
	font-size: 12px;
`
export const cssTextStrikethrough12_100 = css`
	${cssTextStrikethrough12};
	line-height: 100%;
`
export const cssTextStrikethrough12_130 = css`
	${cssTextStrikethrough12};
	line-height: 130%;
`
export const cssTextStrikethrough12_150 = css`
	${cssTextStrikethrough12};
	line-height: 150%;
`
/** */

export const cssTextBold12 = css`
	font-weight: bold;
	font-size: 12px;
`
export const cssTextBold12_100 = css`
	${cssTextBold12}
	line-height: 100%;
`
export const cssTextBold12_130 = css`
	${cssTextBold12}
	line-height: 130%;
`
export const cssTextBold12_150 = css`
	${cssTextBold12}
	line-height: 150%;
`
